import { useAuth } from './useAuth';
import { Role } from '../types';

type Permission = 'full' | 'view' | 'none';

export const useAuthorization = () => {
  const { user } = useAuth();

  const checkPermission = (allowedRoles: Role[]): boolean => {
    if (!user) return false;
    return allowedRoles.includes(user.role);
  };

  // Example of a more complex permission check based on the PDF
  const getPagePermission = (page: string): Permission => {
    if (!user) return 'none';

    const { role } = user;

    switch (page) {
      case 'master-data':
        return role === Role.ADMIN ? 'full' : 'none';
      case 'case-management':
        return [Role.ADMIN, Role.DISPATCHER].includes(role) ? 'full' : 'none';
      case 'dispatch-management':
        return [Role.ADMIN, Role.DISPATCHER].includes(role) ? 'full' : 'view';
      case 'reports':
        return [Role.ADMIN, Role.DISPATCHER, Role.READ_ONLY].includes(role) ? 'view' : 'none';
      default:
        return 'none';
    }
  };

  return { checkPermission, getPagePermission };
};
